import { db, oid } from '../firebase';

export const getBusiness = () => {
  const business = {
    address: null,
    companyName: null
  }
  return db.ref(`appData/${oid}/address`).once('value')
    .then((snapshot) => business.address = snapshot.val())
    .then(() => db.ref(`appData/${oid}/companyName`).once('value'))
    .then((snapshot) => {
      business.companyName = snapshot.val();
      return business;
    })
    .catch((error) =>{
      console.log('getBusiness ERROR:', error);
    })
};



// WEBPACK FOOTER //
// ./src/firebase/database/business.js